import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2'
import { observer } from 'mobx-react'
import { formatNumber } from '../../helpers'

@observer
class GroupedBar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        /**
         * @note
         * React-chartjs-2 can not read Observable array, parse + stringify fix the issue.
         */
        const chartData = JSON.parse(JSON.stringify(this.props.chartOpt.data))
        const chartOpt  = JSON.parse(JSON.stringify(this.props.chartOpt.options))

        chartOpt.tooltips.callbacks = {
            title: function(tooltipItem, data) {
                return data.datasets[tooltipItem[0].datasetIndex].date[tooltipItem[0].index] == 'Försenat' ? 'Försenade ordrar' : 'Att producera '+data.datasets[tooltipItem[0].datasetIndex].date[tooltipItem[0].index]
            },
            label: function(tooltipItem, data) {
                return 'Tid: ' + data.datasets[tooltipItem.datasetIndex].tooltipData[tooltipItem.index] + ' h'
            },
            beforeLabel: function(tooltipItem, data) {
                return 'Ordrar: ' + data.datasets[tooltipItem.datasetIndex].orders[tooltipItem.index] + ' st'
            },
            afterLabel: function(tooltipItem, data) {
                return 'Värde: ' + formatNumber(data.datasets[tooltipItem.datasetIndex].orderValue[tooltipItem.index])
            },
        }

        return <div className="chart-grouped">
            <Bar
                data={ chartData }
                options={ chartOpt }
            />
        </div>
    }
}

export default GroupedBar
